const getDefaultState = () => {
  return {
    shopChosenPackage: null,
    lobbyOffer: null,
    specialOffer: null,
    offerId: "",
    autoShowSpecialOffer: true,
    redirectResult: null,
    sessionId: null,
    transactionId: null,
    paymentCompleted: false,
    paymentError: false,
    paymentStatus: "",
    adyenData: null,
    paymentMethod: "",
    // Global offer state (v2 API)
    globalOfferData: null,
    showGlobalOfferModal: false,
  };
};
const state = getDefaultState();

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setShopChosenPackage(state, payload) {
    state.shopChosenPackage = payload;
  },
  setLobbyOffer(state, payload) {
    state.lobbyOffer = payload;
  },
  setSpecialOffer(state, payload) {
    state.specialOffer = payload;
  },
  setPaymentMethod: (state, string) => (state.paymentMethod = string),
  setPaymentCompleted: (state, boolean) => (state.paymentCompleted = boolean),
  setPaymentError: (state, boolean) => (state.paymentError = boolean),
  setPaymentStatus: (state, string) => (state.paymentStatus = string),
  setTransactionId: (state, number) => (state.transactionId = number),
  setAdyenData: (state, payload) => (state.adyenData = payload),
  setOfferId: (state, string) => (state.offerId = string),
  setAutoShowSpecialOffer: (state, boolean) =>
    (state.autoShowSpecialOffer = boolean),
  setRedirectResult: (state, payload) => (state.redirectResult = payload),
  setSessionID: (state, payload) => (state.sessionId = payload),
  clearLastPayment: (state) => {
    state.redirectResult = null;
    state.sessionId = null;
    state.transactionId = null;
    state.shopChosenPackage = null;
    state.adyenData = null;
    state.paymentCompleted = false;
    state.paymentError = false;
    state.paymentStatus = "";
  },
  // Global offer mutations (v2 API)
  setGlobalOfferData: (state, payload) => {
    state.globalOfferData = payload;
    // Auto-show modal when new offer data is set
    // state.showGlobalOfferModal = true;
  },
  clearGlobalOfferData: (state) => {
    state.globalOfferData = null;
    state.showGlobalOfferModal = false;
  },
  setShowGlobalOfferModal: (state, value) =>
    (state.showGlobalOfferModal = value),
  // Clear all offer state on app init - should not persist between sessions
  initGlobalOfferData: (state, useV2Offers) => {
    state.globalOfferData = null;
    state.showGlobalOfferModal = false;
    // Also clear legacy offer state to prevent stale offers from rendering
    // When v2 is disabled, also clear legacy offer state
    if (!useV2Offers) {
      state.lobbyOffer = null;
      state.specialOffer = null;
      state.offerId = "";
    }
  },
};

const getters = {
  getShopChosenPackage: (state) => state.shopChosenPackage,
  getLobbyOffer: (state) => state.lobbyOffer,
  getSpecialOffer: (state) => state.specialOffer,
  getSpecialOfferTime: (state) => {
    if (!state.specialOffer) return null;
    let time = new Date(state.specialOffer.valid_until).getTime();
    return time;
  },
  getShowBuyResult: (state) =>
    state.transactionId && state.sessionId && state.redirectResult,
  // Global offer getters (v2 API)
  getGlobalOfferData: (state) => state.globalOfferData,
  getShowGlobalOfferModal: (state) => state.showGlobalOfferModal,
};
const actions = {
  resetShopState({ commit }) {
    commit("resetState");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
